/**
 * Accounting Constants for Frontend
 */

export const EXPENSE_CATEGORIES = {
    PRODUCTION: { value: 'production', label: 'Production' },
    MATERIAL: { value: 'material', label: 'Material' },
    PRINTING: { value: 'printing', label: 'Printing' },
    PACKAGING: { value: 'packaging', label: 'Packaging' },
    SHIPPING: { value: 'shipping', label: 'Shipping' },
    PLATFORM_FEES: { value: 'platform_fees', label: 'Platform Fees' },
    PAYMENT_GATEWAY_FEES: { value: 'payment_gateway_fees', label: 'Payment Gateway Fees' },
    MARKETING: { value: 'marketing', label: 'Marketing' },
    SALARY: { value: 'salary', label: 'Salary' },
    RENT: { value: 'rent', label: 'Rent' },
    UTILITIES: { value: 'utilities', label: 'Utilities' },
    OFFICE_SUPPLIES: { value: 'office_supplies', label: 'Office Supplies' },
    SOFTWARE: { value: 'software', label: 'Software' },
    OTHER: { value: 'other', label: 'Other' }
};

export const EXPENSE_STATUSES = {
    PENDING: { value: 'pending', label: 'Pending', badge: 'warning' },
    APPROVED: { value: 'approved', label: 'Approved', badge: 'success' },
    REJECTED: { value: 'rejected', label: 'Rejected', badge: 'critical' },
    PAID: { value: 'paid', label: 'Paid', badge: 'info' },
    CANCELLED: { value: 'cancelled', label: 'Cancelled', badge: 'subdued' }
};

export const TRANSACTION_TYPES = {
    REVENUE: { value: 'revenue', label: 'Revenue', badge: 'success' },
    EXPENSE: { value: 'expense', label: 'Expense', badge: 'critical' },
    REFUND: { value: 'refund', label: 'Refund', badge: 'warning' },
    ADJUSTMENT: { value: 'adjustment', label: 'Adjustment', badge: 'info' },
    TRANSFER: { value: 'transfer', label: 'Transfer', badge: 'subdued' }
};

export const TRANSACTION_STATUSES = {
    PENDING: { value: 'pending', label: 'Pending', badge: 'warning' },
    COMPLETED: { value: 'completed', label: 'Completed', badge: 'success' },
    FAILED: { value: 'failed', label: 'Failed', badge: 'critical' },
    VOIDED: { value: 'voided', label: 'Voided', badge: 'subdued' },
    RECONCILED: { value: 'reconciled', label: 'Reconciled', badge: 'info' }
};

export const ACCOUNTING_PERIODS = {
    CURRENT_MONTH: { value: 'current_month', label: 'Current Month' },
    LAST_MONTH: { value: 'last_month', label: 'Last Month' },
    LAST_3_MONTHS: { value: 'last_3_months', label: 'Last 3 Months' },
    LAST_6_MONTHS: { value: 'last_6_months', label: 'Last 6 Months' },
    CURRENT_YEAR: { value: 'current_year', label: 'Current Year' },
    LAST_YEAR: { value: 'last_year', label: 'Last Year' },
    CUSTOM: { value: 'custom', label: 'Custom Range' }
};

export const REPORT_TYPES = {
    PROFIT_LOSS: { value: 'profit_loss', label: 'Profit & Loss' },
    REVENUE_SUMMARY: { value: 'revenue_summary', label: 'Revenue Summary' },
    EXPENSE_BREAKDOWN: { value: 'expense_breakdown', label: 'Expense Breakdown' },
    PRODUCT_PROFITABILITY: { value: 'product_profitability', label: 'Product Profitability' },
    CUSTOMER_PROFITABILITY: { value: 'customer_profitability', label: 'Customer Profitability' },
    PAYMENT_METHOD_ANALYSIS: { value: 'payment_method_analysis', label: 'Payment Method Analysis' },
    CASH_FLOW: { value: 'cash_flow', label: 'Cash Flow' }
};

export const GROUPING_OPTIONS = {
    DAILY: { value: 'daily', label: 'Daily' },
    WEEKLY: { value: 'weekly', label: 'Weekly' },
    MONTHLY: { value: 'monthly', label: 'Monthly' },
    QUARTERLY: { value: 'quarterly', label: 'Quarterly' },
    YEARLY: { value: 'yearly', label: 'Yearly' }
};

export const CURRENCY_SYMBOL = 'EGP';

export const DEFAULT_CURRENCY = 'EGP';

// ==================== SETTLEMENT SOURCES ====================
export const SETTLEMENT_SOURCES = {
    BOSTA: { value: 'bosta', label: 'Bosta COD' },
    PAYMOB: { value: 'paymob', label: 'Paymob' },
    FAWRY: { value: 'fawry', label: 'Fawry' },
    INSTAPAY: { value: 'instapay', label: 'InstaPay' },
    BANK_TRANSFER: { value: 'bank_transfer', label: 'Bank Transfer' },
    CASH: { value: 'cash', label: 'Cash' },
    OTHER: { value: 'other', label: 'Other' }
};

// ==================== COMMISSION STATUSES ====================
export const COMMISSION_STATUSES = {
    PENDING: { value: 'pending', label: 'Pending', badge: 'warning' },
    CALCULATED: { value: 'calculated', label: 'Calculated', badge: 'info' },
    PAID: { value: 'paid', label: 'Paid', badge: 'success' }
};

// ==================== BUDGET HEALTH ====================
export const BUDGET_HEALTH = {
    HEALTHY: { value: 'healthy', label: 'Healthy', badge: 'success', color: '#4CAF50' },
    WARNING: { value: 'warning', label: 'Warning', badge: 'warning', color: '#FF9800' },
    CRITICAL: { value: 'critical', label: 'Over Budget', badge: 'critical', color: '#F44336' }
};

// ==================== RECURRING FREQUENCIES ====================
export const RECURRING_FREQUENCIES = {
    DAILY: { value: 'daily', label: 'Daily' },
    WEEKLY: { value: 'weekly', label: 'Weekly' },
    MONTHLY: { value: 'monthly', label: 'Monthly' },
    QUARTERLY: { value: 'quarterly', label: 'Quarterly' },
    YEARLY: { value: 'yearly', label: 'Yearly' }
};

// ==================== RECURRING STATUSES ====================
export const RECURRING_STATUSES = {
    ACTIVE: { value: 'active', label: 'Active', badge: 'success' },
    PAUSED: { value: 'paused', label: 'Paused', badge: 'warning' },
    CANCELLED: { value: 'cancelled', label: 'Cancelled', badge: 'subdued' },
    COMPLETED: { value: 'completed', label: 'Completed', badge: 'info' }
};

// ==================== ALERT TYPES ====================
export const ALERT_TYPES = {
    DANGER: { value: 'danger', icon: 'AlertCircle', color: 'critical' },
    WARNING: { value: 'warning', icon: 'AlertTriangle', color: 'warning' },
    INFO: { value: 'info', icon: 'Info', color: 'info' }
};

// ==================== CASH DIRECTIONS ====================
export const CASH_DIRECTIONS = {
    IN: { value: 'IN', label: 'Cash In', badge: 'success' },
    OUT: { value: 'OUT', label: 'Cash Out', badge: 'critical' }
};

// ==================== TAX RATES (Egypt) ====================
export const TAX_RATES = {
    VAT_STANDARD: 14,
    PROFIT_TAX_STANDARD: 22.5,
    SMALL_BUSINESS_THRESHOLD: 500000
};

/**
 * Helper functions
 */
export const accountingHelpers = {
    /**
     * Get expense category label
     */
    getExpenseCategoryLabel(value) {
        const category = Object.values(EXPENSE_CATEGORIES).find(cat => cat.value === value);
        return category ? category.label : value;
    },

    /**
     * Get expense status badge
     */
    getExpenseStatusBadge(value) {
        const status = Object.values(EXPENSE_STATUSES).find(s => s.value === value);
        return status ? status.badge : 'subdued';
    },

    /**
     * Get transaction type badge
     */
    getTransactionTypeBadge(value) {
        const type = Object.values(TRANSACTION_TYPES).find(t => t.value === value);
        return type ? type.badge : 'subdued';
    },

    /**
     * Format currency
     */
    formatCurrency(amount, currency = DEFAULT_CURRENCY) {
        if (amount === null || amount === undefined) return '-';
        if (currency === '') return Number(amount);
        try {
            return new Intl.NumberFormat('en-EG', {
                style: 'currency',
                currency: currency
            }).format(amount);
        } catch (error) {
            return `${currency} ${Number(amount).toFixed(2)}`;
        }
    },

    /**
     * Format percentage
     */
    formatPercentage(value) {
        if (value === null || value === undefined) return '-';
        return `${Number(value).toFixed(2)}%`;
    },

    /**
     * Format accounting period (YYYY-MM) to readable format
     */
    formatAccountingPeriod(period) {
        if (!period) return '-';

        try {
            const [year, month] = period.split('-');
            const date = new Date(year, parseInt(month) - 1);
            return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
        } catch (error) {
            return period;
        }
    },

    /**
     * Get current accounting period (YYYY-MM)
     */
    getCurrentPeriod() {
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
    },

    /**
     * Get last month's accounting period
     */
    getLastMonthPeriod() {
        const now = new Date();
        now.setMonth(now.getMonth() - 1);
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        return `${year}-${month}`;
    },

    /**
     * Get profit/loss color
     */
    getProfitLossColor(value) {
        if (value === null || value === undefined || value === 0) return 'subdued';
        return value > 0 ? 'success' : 'critical';
    },

    /**
     * Get margin color
     */
    getMarginColor(percentage) {
        if (percentage === null || percentage === undefined) return 'subdued';
        if (percentage >= 40) return 'success';
        if (percentage >= 20) return 'warning';
        if (percentage >= 0) return 'attention';
        return 'critical';
    }
};

/**
 * Get expense category options for select dropdown
 */
export const getExpenseCategoryOptions = () => {
    return Object.values(EXPENSE_CATEGORIES).map(cat => ({
        label: cat.label,
        value: cat.value
    }));
};

/**
 * Get expense status options for select dropdown
 */
export const getExpenseStatusOptions = () => {
    return Object.values(EXPENSE_STATUSES).map(status => ({
        label: status.label,
        value: status.value
    }));
};

/**
 * Get transaction type options for select dropdown
 */
export const getTransactionTypeOptions = () => {
    return Object.values(TRANSACTION_TYPES).map(type => ({
        label: type.label,
        value: type.value
    }));
};

/**
 * Get accounting period options for select dropdown
 */
export const getAccountingPeriodOptions = () => {
    return Object.values(ACCOUNTING_PERIODS).map(period => ({
        label: period.label,
        value: period.value
    }));
};

/**
 * Get settlement source options for select dropdown
 */
export const getSettlementSourceOptions = () => {
    return Object.values(SETTLEMENT_SOURCES).map(source => ({
        label: source.label,
        value: source.value
    }));
};

/**
 * Get commission status options for select dropdown
 */
export const getCommissionStatusOptions = () => {
    return Object.values(COMMISSION_STATUSES).map(status => ({
        label: status.label,
        value: status.value
    }));
};

/**
 * Get recurring frequency options for select dropdown
 */
export const getRecurringFrequencyOptions = () => {
    return Object.values(RECURRING_FREQUENCIES).map(freq => ({
        label: freq.label,
        value: freq.value
    }));
};

/**
 * Get recurring status options for select dropdown
 */
export const getRecurringStatusOptions = () => {
    return Object.values(RECURRING_STATUSES).map(status => ({
        label: status.label,
        value: status.value
    }));
};

/**
 * Get budget health status based on utilization percentage
 */
export const getBudgetHealthStatus = (utilizationPercent) => {
    if (utilizationPercent >= 100) return BUDGET_HEALTH.CRITICAL;
    if (utilizationPercent >= 80) return BUDGET_HEALTH.WARNING;
    return BUDGET_HEALTH.HEALTHY;
};

/**
 * Format trend indicator (up/down arrow with color)
 */
export const formatTrendIndicator = (changePercent) => {
    if (changePercent === null || changePercent === undefined) return { icon: '', color: 'subdued' };
    if (changePercent > 0) return { icon: '↑', color: 'success', text: `+${changePercent.toFixed(1)}%` };
    if (changePercent < 0) return { icon: '↓', color: 'critical', text: `${changePercent.toFixed(1)}%` };
    return { icon: '→', color: 'subdued', text: '0%' };
};
